import { faXmark } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React from "react";
import { Table, Row, Col, Spinner } from "react-bootstrap";
import StarRatings from "react-star-ratings";
import { SkillSearchInput } from "../../../../_uiComponents/Search/SkillSearchInput";
import SkillExperienceBasic from "../../../../_uiComponents/SkillExperienceBasic";
import useSkillsInformation from "./useSkillsInformation";

export default (props) => {
  const {
    skillsTagsAdded,
    skillsListLoading,
    searchKeywordsSuggestions,
    onKeywordsTagsAddition,
    onKeywordsTagsDelete,
    onSkillChange,
  } = useSkillsInformation(props);

  const primarySkillCount =
    Array.isArray(skillsTagsAdded) &&
    skillsTagsAdded.filter((item) => item.is_primary).length;

  return (
    <div className="hiring-process-dashboard  hiring-manager-profile-wrapper edit-candidate-details">
      <div className="job-detail-wrapper mt-4  pr-lg-4">
        <div className="col-xl-8">
          <h2 className="mb-3">{"Skills & Experience"}</h2>
          <div className="py-3 form-group mb-0">
            <Row>
              <Col lg={12} className=" bg-white p-4 border-radius-10 border mb-3">
                <div className="form-group">
                  <p className="font-weight-medium">
                    <span className="text-danger">* </span>Skills
                  </p>
                  <div className=" mw-100">

                    <SkillSearchInput
                      placeholder="Search Skill..."
                      onSearchSelect={(item) => onKeywordsTagsAddition(item)}
                      clearSearch={true}
                    />
                    {Array.isArray(searchKeywordsSuggestions) &&
                      searchKeywordsSuggestions &&
                      searchKeywordsSuggestions.length ? (
                      <ul
                        className="rounded-lg bg-white shadow position-absolute w-75 pb-4"
                        style={{ left: "40px", top: "70%", zIndex: 9 }}
                      >
                        {Array.isArray(searchKeywordsSuggestions) &&
                          searchKeywordsSuggestions.map((item, index) => (
                            <li
                              className="p-0 fs-smallest"
                              onClick={(e) => onKeywordsTagsAddition(item)}
                              key={index}
                            >
                              <p className="fs-smallest mx-1 pl-lg-5 pl-md-4">
                                {item}
                              </p>
                            </li>
                          ))}
                      </ul>
                    ) : null}
                    <div className="d-flex flex-wrap align-items-center">
                      {skillsTagsAdded &&
                        Array.isArray(skillsTagsAdded) &&
                        skillsTagsAdded.map((tag, index) => (
                          <div
                            className="h4 bg-grey py-1 rounded font-weight-normal text-dark px-2 mr-2 text-capitalize mt-3"
                            onClick={() => onKeywordsTagsDelete(tag)}
                            key={index}
                          >
                            {tag?.skill_name}
                            <FontAwesomeIcon
                              icon={faXmark}
                              className="ml-3"
                            />
                          </div>
                        ))}
                    </div>
                  </div>
                </div>
              </Col>
              <Col lg={12} className="mb-3  bg-white p-4 border-radius-10 border">
                <h2 className="my-3">Primary Skills
                </h2>
                <p>Select Top 5 primary skills</p>

                {skillsListLoading ? (
                  <div className="d-flex justify-content-center align-items-center w-100">
                    <Spinner animation="border" variant="primary" />
                  </div>
                ) : (
                  <Table
                  borderless>
                  <thead>
                    <tr className="align-items-center my-2">
                      <th className="form-group mb-0">
                        <h4 className=" px-2">
                          Skill Name
                        </h4>
                      </th>
                      <th >
                        <h4>Rating out of 5</h4>
                      </th>
                      <th >
                        <h4>Experience in years</h4>
                      </th>
                      <th className="custom-control custom-checkbox">
                        <h4>Primary Skill</h4>
                      </th>
                    </tr>
                  </thead>
                  {Array.isArray(skillsTagsAdded) &&
                    skillsTagsAdded.map((item) => (
                      <>
                        {item?.is_primary ? (
                          <tr className="align-items-center my-2">
                            <td className="form-group mb-0">
                              <span className="bg-grey rounded-sm px-2">
                                {item?.skill_name}
                              </span>
                            </td>
                            <td>
                              <StarRatings
                                rating={item?.rating}
                                starRatedColor="#FFCC2A"
                                changeRating={(e) =>
                                  onSkillChange(e, "rating", item)
                                }
                                numberOfStars={5}
                                name="rating"
                                starDimension="24"
                                starHoverColor="#FCDDB0"
                              />
                            </td>
                            <td className="w-25">
                              <SkillExperienceBasic
                                onSkillExperienceChange={(expValue) =>
                                  onSkillChange(expValue, "experience", item)
                                }
                                selectedValue={item?.experience}
                                selectedKey={"experience"}
                              />
                            </td>
                            <td className="custom-control custom-checkbox">
                              <input
                                type="checkbox"
                                className="custom-control-input d-none"
                                id={item?.id}
                                name="is_primary"
                                defaultChecked={item?.is_primary}
                                onClick={(e) =>
                                  onSkillChange(false, "is_primary", item)
                                }
                              />
                              <label
                                className="custom-control-label font-weight-medium ml-4"
                                htmlFor={item?.id}
                              >
                                Primary
                              </label>
                            </td>
                          </tr>
                        ) : null}
                      </>
                    ))}
                </Table>
                )}
              </Col>

              <Col lg={12} className="bg-white p-4 border-radius-10 border" >
                <h2 className="font-weight-medium">Secondary Skills
                </h2>

                {skillsListLoading ? (
                  <div className="d-flex justify-content-center align-items-center w-100">
                    <Spinner animation="border" variant="primary" />
                  </div>
                ) : (
                  <div className="">
                    {skillsTagsAdded &&
                      Array.isArray(skillsTagsAdded) &&
                      skillsTagsAdded.map((item) => (
                        <>
                          {item?.is_primary ? null : (
                            <div className="row align-items-center my-2 row">
                              <div className="form-group col-lg-3 mb-0">
                                <span className="bg-grey px-2 rounded-sm">{item?.skill_name}</span>
                              </div>
                              <div className="col-lg-4">
                                <StarRatings
                                  rating={item?.rating}
                                  starRatedColor="#FFCC2A"
                                  changeRating={(e) =>
                                    onSkillChange(e, "rating", item)
                                  }
                                  numberOfStars={5}
                                  name="rating"
                                  starDimension="24"
                                  className=""
                                  starHoverColor="#FCDDB0"
                                />
                              </div>
                              <div className="col-lg-2">
                                <SkillExperienceBasic
                                  onSkillExperienceChange={(expValue) =>
                                    onSkillChange(
                                      expValue,
                                      "experience",
                                      item
                                    )
                                  }
                                  selectedValue={item?.experience}
                                  selectedKey={"experience"}
                                />
                              </div>
                              {primarySkillCount !== 5 ? (
                                <>
                                  <div className="custom-control custom-checkbox col-lg-3">
                                    <input
                                      type="checkbox"
                                      className="custom-control-input d-none"
                                      id={item?.id}
                                      name="is_primary"
                                      defaultChecked={item?.is_primary}
                                      onClick={(e) =>
                                        onSkillChange(
                                          true,
                                          "is_primary",
                                          item
                                        )
                                      }
                                    />
                                    <label
                                      className="custom-control-label font-weight-medium ml-5"
                                      htmlFor={item?.id}
                                    >
                                      Primary
                                    </label>
                                  </div>
                                </>
                              ) : null}
                            </div>
                          )}
                        </>
                      ))}
                  </div>
                )}
              </Col>
            </Row>
          </div>
        </div>
      </div>
    </div>
  ); 
};
